import { Card, CardContent, CardFooter, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

const PaymentFlowCardSkeleton = ({ showFooter = false }: { showFooter?: boolean }) => {
    return (
        <Card className="flex flex-col gap-0 overflow-hidden py-0">
            {/* Header: Title + Menu button */}
            <CardHeader className="p-4 pb-2">
                <div className="flex items-start justify-between gap-3">
                    <div className="flex min-w-0 flex-1 items-center gap-2">
                        <Skeleton className="h-5 w-32" />
                        {/* Some cards have Default badge */}
                        {!showFooter && <Skeleton className="h-4 w-14 rounded-full" />}
                    </div>
                    <Skeleton className="h-8 w-8 shrink-0 rounded-md" />
                </div>
            </CardHeader>

            {/* Content: Badges + Processors */}
            <CardContent className="flex-1 space-y-3 p-4 pt-0">
                {/* Feature badges row */}
                <div className="flex flex-wrap items-center gap-2">
                    <Skeleton className="h-4 w-16" />
                    <Skeleton className="h-5 w-12 rounded-full" />
                    <Skeleton className="h-5 w-20 rounded-full" />
                </div>

                {/* Processors section */}
                <div className="space-y-1.5">
                    <Skeleton className="h-3 w-20" />
                    <div className="flex flex-wrap gap-2">
                        <Skeleton className="h-8 w-28 rounded-md" />
                        <Skeleton className="h-8 w-24 rounded-md" />
                    </div>
                </div>
            </CardContent>

            {/* Footer: Set as Default button (only for non-default cards) */}
            {showFooter && (
                <CardFooter className="p-3 pt-0">
                    <Skeleton className="h-8 w-full rounded-md" />
                </CardFooter>
            )}
        </Card>
    )
}

export const PaymentFlowsLoading = () => {
    return (
        <div className="space-y-6">
            {/* Page header */}
            <div className="flex items-center justify-between">
                <div className="space-y-1">
                    <Skeleton className="h-8 w-40" />
                    <Skeleton className="h-4 w-72" />
                </div>
                <Skeleton className="h-10 w-36 rounded-md" />
            </div>

            {/* Cards grid */}
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                {/* First card is "default" - no footer */}
                <PaymentFlowCardSkeleton showFooter={false} />
                {/* Other cards have footer */}
                {[...Array(5)].map((_, i) => (
                    <PaymentFlowCardSkeleton key={i} showFooter={true} />
                ))}
            </div>
        </div>
    )
}
